// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const shiftry: PokeData = {
  "id": 275,
  "name": "shiftry",
  "height": 13,
  "weight": 596,
  "base_experience": 216,
  "types": [
    PokeType.GRASS,
    PokeType.DARK
  ],
  "api_moves": [
    "pound",
    "whirlwind",
    "tackle",
    "absorb",
    "mega-drain",
    "growth",
    "razor-leaf",
    "harden",
    "explosion",
    "feint-attack",
    "rollout",
    "swagger",
    "synthesis",
    "sunny-day",
    "fake-out",
    "torment",
    "nature-power",
    "astonish",
    "air-cutter",
    "extrasensory",
    "leaf-blade",
    "payback",
    "sucker-punch",
    "nasty-plot",
    "leaf-storm",
    "leaf-tornado",
    "hurricane"
  ],
  "moves": [
    "tackle",
    "razor-leaf",
    "synthesis",
    "sunny-day",
    "leaf-tornado",
    "hurricane",
    "energy-ball",
    "snarl",
    "solar-beam",
    "frenzy-plant",
    "dark-bargain",
    "overgrowth",
    "vine-whip"
  ],
  "evolution_chain": {
    "id": 137,
    "item": null,
    "species": [
      {
        "name": "seedot",
        "order": 298,
        "types": [
          PokeType.GRASS
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "nuzleaf",
        "order": 299,
        "types": [
          PokeType.GRASS,
          PokeType.DARK
        ],
        "evolves_from_species_id": 273,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 14,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "shiftry",
        "order": 300,
        "types": [
          PokeType.GRASS,
          PokeType.DARK
        ],
        "evolves_from_species_id": 274,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": {
              "name": "leaf-stone"
            },
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.USE_ITEM
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 118,
    "speed": 125,
    "ability_power": 157
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
